<h1 mat-dialog-title>Hi</h1>
<div mat-dialog-content>
  <div style="font-size: 1.4em; line-height: 0.8em" id="htmlData">
    <div style="text-align: center; padding-bottom: 0.9em; line-height: 1.35em">
      <p id="lblCustomerName"></p>
    </div>
    <hr />
    <p id="lblRef"></p>

    <span style="padding-left: 3em">TOTAL PALLETS:</span>

    <p id="lblTotalPallets"></p>
    <hr />
    <p id="lblContainer"></p>

    <hr />
    <div style="font-size: 1em">
        <p id="lblETA"></p>
        <p id="lblReceived"> </p>
  
    </div>

    <div
      style="
        text-align: center;
        display: inline-flex;
        width: 100%;
        padding-top: 0.5em;
        justify-content: space-between;
      "
    >
    <ngx-barcode
                      [bc-value]="2131231"
                      [bc-display-value]="true"
                      bc-format="CODE39"
                    ></ngx-barcode>
      
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Ok</button>
</div>
